/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationTypeDTO } from '../models/NotificationTypeDTO';
import type { NotificationTypeRequest } from '../models/NotificationTypeRequest';
import type { UserNotificationSettingsReq } from '../models/UserNotificationSettingsReq';
import type { UserNotificationSettingsResp } from '../models/UserNotificationSettingsResp';
import type { UserNotificationsSettingsReq } from '../models/UserNotificationsSettingsReq';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationService {

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postNotificationSendBannerState(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Notification/SendBannerState',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postNotificationSendNewBannerState(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Notification/SendNewBannerState',
    });
  }

  /**
   * @param leadId 
   * @returns any Success
   * @throws ApiError
   */
  public static postNotificationNewLeadNotification(
leadId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Notification/NewLeadNotification',
      query: {
        'leadId': leadId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postNotificationSettings(
requestBody?: UserNotificationSettingsReq,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Notification/settings',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postNotificationType(
requestBody?: NotificationTypeRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Notification/type',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteNotificationType(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Notification/type/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns NotificationTypeDTO Success
   * @throws ApiError
   */
  public static patchNotificationType(
id: number,
requestBody?: NotificationTypeRequest,
): CancelablePromise<NotificationTypeDTO> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/Notification/type/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param name 
   * @param code 
   * @param template 
   * @returns NotificationTypeDTO Success
   * @throws ApiError
   */
  public static getNotificationTypes(
name?: string,
code?: string,
template?: string,
): CancelablePromise<Array<NotificationTypeDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Notification/types',
      query: {
        'Name': name,
        'Code': code,
        'Template': template,
      },
    });
  }

  /**
   * Get list of Notifications assigned by specific Notification Type
   * @param id Type Id to get Notification settings
   * @returns UserNotificationSettingsResp Success
   * @throws ApiError
   */
  public static getNotificationTypeSettings(
id: number,
): CancelablePromise<Array<UserNotificationSettingsResp>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Notification/type/settings/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns UserNotificationSettingsResp Success
   * @throws ApiError
   */
  public static getNotificationSettings(
id: number,
): CancelablePromise<UserNotificationSettingsResp> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Notification/settings/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns UserNotificationSettingsResp Success
   * @throws ApiError
   */
  public static patchNotificationSettings(
id: number,
requestBody?: UserNotificationSettingsReq,
): CancelablePromise<UserNotificationSettingsResp> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/Notification/settings/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteNotificationSettings(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Notification/settings/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * Update Notifications Setting for specific Type, Branch by Users id list
   * @param requestBody 
   * @returns UserNotificationSettingsResp Success
   * @throws ApiError
   */
  public static patchNotificationTypeSettings(
requestBody?: UserNotificationsSettingsReq,
): CancelablePromise<UserNotificationSettingsResp> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/Notification/type/settings',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
